import React from 'react'
import Navbar from './Components/Navbar';
import Slider from './Components/Slider';
import AboutUs from './Components/AboutUs';
import Gallery from './Components/Gallery';
import Contact from './Components/Contact';
import Footer from './Components/Footer';


const Index = () => {
  return (
    <>
    <Navbar />
    <Slider />
    <AboutUs />
    <Gallery />
    <Contact />
    <Footer />
    </>
  )
}

export default Index;
